import { EditUserNameModal } from 'components';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { User, Credentials } from 'model'
import { createStructuredSelector } from 'reselect';
import { RootState } from 'model/state';
import { saveUser } from 'actions/User';
import { selectUserId, selectIsSubmitting, selectCurrentUser, selectCurrentIsLoading } from 'selectors';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  saveUser: (user: User, credentials?: Credentials) => dispatch(saveUser(user, credentials)),
});

type SelectedValues = {
  currentUser?: User,
  isLoading: boolean,
  isSubmitting: boolean,
  authenticatedUserId?: string | null,
}

const mapStateToProps = createStructuredSelector<RootState, SelectedValues>({
  currentUser: selectCurrentUser(),
  isLoading: selectCurrentIsLoading(),
  isSubmitting: selectIsSubmitting(),
  authenticatedUserId: selectUserId(),
});


export default connect(mapStateToProps, mapDispatchToProps)(EditUserNameModal);